import { formatAmount, formatDate } from '@/util/helpers'
import Pagination from '@/util/pagination'
import discountCouponTypes from '@/util/discountCouponTypes'

export default function () {
  return {
    formatAmount,
    formatDate,
    coupons: [],
    validFromPicker: false,
    validUntilPicker: false,
    discountCouponTypes,
    filters: {
      code: '',
      type: [],
      firstPurchaseOnly: null,
      'validFrom[after]': null,
      'validUntil[before]': null,
    },
    pagination: new Pagination(),
  }
}
